<template>
  <div class="baoxiuBox">
      <el-card>
        {{data}}
      </el-card>
  </div>
</template>

<script>
  import {getJjyy} from "@/api";

  export default {
    data() {
      return {
        data: ''
      };
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData() {
        let params = {
          id: this.$route.query.id
        }
        getJjyy(params).then(res=>{
          this.data = res.data
        })
      }
    },
  };
</script>
<style  scoped>
  .baoxiuBox {
    /* background: #fff; */
    padding: 3% 3%;
    min-height: 90%;
  }
  .baoxiuBox .el-select {
    width: 100%;
  }

</style>




// WEBPACK FOOTER //
// src/view/ywbl/jjyy.vue